package meineglasfaser.frontend.www.pages.explore

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.css.role
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.RouteInfo
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.navigation.Anchor
import io.ktor.http.*
import meineglasfaser.api.routes.ShopRoutes
import meineglasfaser.frontend.common.BackendApi
import meineglasfaser.frontend.common.components.widgets.rememberQuery
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

internal fun RouteInfo.networkIdBy(name: String) = params.getValue(name)

@Page("{audience}/{category}/{network}")
@Layout(".components.layouts.ShopLayout")
@Composable
fun NetworkPage(ctx: PageContext) {
    val customerType = ctx.route.customerTypeBy("audience")
    val category = ctx.route.categoryBy("category")
    val networkId = ctx.route.networkIdBy("network")

    val data = rememberQuery<ShopRoutes.Query.Products.ResponseBody?>(null, ctx.route) {
        BackendApi.get(ShopRoutes.Query.Products(customerType, category, networkId))
    }

    data?.let { data ->
        Div {
            H1 { Text(data.network.title) }
            P { Text(data.network.summary) }
            P { Text(data.network.details) }
            Div({ classes("row-fluid") }) {
                data.products.forEach { product ->
                    Div({ classes("col-12", "col-md-6", "col-lg-4") }) {
                        val href = URLBuilder().takeFrom(ctx.route.path).run {
                            appendPathSegments(product.nid.toString())
                            encodedPath
                        }
                        ProductView(product, customerType) {
                            Anchor(href, {
                                role("button")
                                classes("product-btn")
                            }) {
                                Text("Produkt anzeigen")
                            }
                        }
                    }
                }
            }
        }
    }
}
